import * as React from "react";
import { Collapse, Slider, Input } from "antd";
import styled from "styled-components";
import update from "immutability-helper";
import { ThemeContext } from "../../../../themeDesigner";

const Panel = Collapse.Panel;

const Label = styled.label`
  font-family: Muli;
  font-size: 13px;
  font-weight: 600;
  color: #7f90af;
  display: block;
  margin-bottom: 8px;
`;

const SettingRow = styled.div`
  margin-bottom: 16px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
  }
`;

export default function TypographyProperties() {
  const { themeProps, setThemeProps } = React.useContext(ThemeContext);
  const typography = themeProps.widget.modernUIStyles.typography;

  const handleUpdate = (key: string, value: any) => {
    const numValue = typeof value === "number" ? value : (Array.isArray(value) ? value[0] : value);
    const updated = update(themeProps, {
      widget: {
        modernUIStyles: {
          typography: {
            [key]: { $set: numValue },
          },
        },
      },
    });
    setThemeProps(updated);
  };

  return (
    <Collapse defaultActiveKey={["1"]}>
      <Panel header="Typography Settings" key="1">
        <SettingRow>
          <Label>Message Font Size (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={typography.messageFontSize}
              onChange={(e) =>
                handleUpdate("messageFontSize", parseInt(e.target.value) || 14)
              }
              min={10}
              max={24}
            />
            <span>{typography.messageFontSize}px</span>
          </Wrapper>
          <Slider
            value={typography.messageFontSize}
            onChange={(val) => handleUpdate("messageFontSize", val)}
            min={10}
            max={24}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Message Font Weight</Label>
          <Wrapper>
            <Input
              type="number"
              value={typography.messageFontWeight}
              onChange={(e) =>
                handleUpdate("messageFontWeight", parseInt(e.target.value) || 400)
              }
              min={300}
              max={700}
              step={100}
            />
            <span>{typography.messageFontWeight}</span>
          </Wrapper>
          <Slider
            value={typography.messageFontWeight}
            onChange={(val) => handleUpdate("messageFontWeight", val)}
            min={300}
            max={700}
            step={100}
            style={{ marginTop: "8px" }}
            marks={{
              300: "Light",
              400: "Regular",
              500: "Medium",
              600: "Semibold",
              700: "Bold",
            }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Line Height</Label>
          <Wrapper>
            <Input
              type="number"
              value={typography.messageLineHeight}
              onChange={(e) =>
                handleUpdate("messageLineHeight", parseFloat(e.target.value) || 1.5)
              }
              min={1}
              max={2}
              step={0.1}
            />
            <span>{typography.messageLineHeight.toFixed(1)}x</span>
          </Wrapper>
          <Slider
            value={Math.round(typography.messageLineHeight * 100)}
            onChange={(val) => {
              const numVal = typeof val === "number" ? val : val[0];
              handleUpdate("messageLineHeight", numVal / 100);
            }}
            min={100}
            max={200}
            step={10}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Letter Spacing (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={typography.messageLetterSpacing}
              onChange={(e) =>
                handleUpdate("messageLetterSpacing", parseFloat(e.target.value) || 0.2)
              }
              min={-0.5}
              max={1}
              step={0.1}
            />
            <span>{typography.messageLetterSpacing.toFixed(1)}px</span>
          </Wrapper>
          <Slider
            value={Math.round((typography.messageLetterSpacing + 0.5) * 100)}
            onChange={(val) => {
              const numVal = typeof val === "number" ? val : val[0];
              handleUpdate("messageLetterSpacing", numVal / 100 - 0.5);
            }}
            min={0}
            max={150}
            step={5}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>
      </Panel>
    </Collapse>
  );
}
